/* eslint-disable no-undef */

import { mqLgTablet } from "../utils/helpers";

export function useGsapAnimations() {
  const { matches: prefersReducedMotion } = window.matchMedia(
    "(prefers-reduced-motion)"
  );

  // Return out before implementing any animations.
  if (prefersReducedMotion) return;

  gsap.registerPlugin(ScrollTrigger);

  // Banners - Split
  if (mqLgTablet) {
    const banner_split = document.querySelector(
      ".banner.banner-split .banner-split__content"
    );
    gsap.from(banner_split, {
      x: "-66vw",
      duration: 1,
    });
  }

  // Section Banners - Split
  const section_banners_split = document.querySelectorAll(
    ".section-flexible.banner-split"
  );

  section_banners_split.forEach((split) => {
    if (mqLgTablet) {
      const flipped = split.classList.contains("banner-split--text-right");

      const content = split.querySelector(".banner-split__content");

      gsap.from(content, {
        scrollTrigger: {
          trigger: content,
          start: `top center`,
          end: `center-=100 center`,
          scrub: true,
        },
        x: flipped ? "66vw" : "-66vw",
        duration: 2,
      });
    }
  });

  // ------------------ DECORATIONS ------------------ //

  // Asterisk
  const decoration_asterisks = document.querySelectorAll(
    ".decoration--asterisks svg"
  );

  decoration_asterisks.forEach((asterisk) => {
    gsap.from(asterisk, {
      rotate: 360,
      duration: 15,
      ease: "linear",
      repeat: -1,
    });
  });

  // Ball - Aqua
  const decoration_ball_aqua = document.querySelectorAll(
    ".decoration--ball-aqua svg"
  );

  decoration_ball_aqua.forEach((ball_aqua) => {
    const tl_ball_aqua = gsap.timeline({
      scrollTrigger: {
        trigger: ball_aqua,
        start: `top center`,
        end: `center center`,
      },
    });

    const shapes = Array.from(ball_aqua.children);

    shapes.forEach((shape) => {
      const shapeName = shape.classList[0].split("__")[1];
      // console.log(shapeName);
      switch (shapeName) {
        case "ball":
          tl_ball_aqua.from(shape, { x: -75, y: 85, opacity: 0 });
          break;
        case "dashed-right":
          tl_ball_aqua.from(shape, { opacity: 0 }, "-=0.666");
          break;
        case "dashed-left":
          tl_ball_aqua.from(shape, { opacity: 0 }, "-=0.666");
          break;
        case "dash-1":
          tl_ball_aqua.from(shape, { opacity: 0 }, "-=0.666");
          break;
        case "dash-2":
          tl_ball_aqua.from(shape, { opacity: 0 }, "-=0.5");
          break;
        case "dash-3":
          tl_ball_aqua.from(shape, { opacity: 0 }, "-=0.25");
          break;
        case "squiggle-right":
          tl_ball_aqua.from(
            shape,
            { opacity: 0, x: 5, y: -10, duration: 0.25 },
            "-=0.25"
          );
          break;
        case "squiggle-left":
          tl_ball_aqua.from(
            shape,
            { opacity: 0, x: 10, y: -15, duration: 0.25 },
            "-=0.25"
          );
          break;
        default:
          break;
      }
    });
  });

  // Ball - Horizontal
  const decoration_ball_horizontal = document.querySelectorAll(
    ".decoration--ball-horizontal svg"
  );

  decoration_ball_horizontal.forEach((ball_horizontal) => {
    const tl_ball_horizontal = gsap.timeline({
      scrollTrigger: {
        trigger: ball_horizontal,
        start: `top center`,
        end: `center center`,
      },
    });

    const shapes = Array.from(ball_horizontal.children);

    shapes.forEach((shape) => {
      const shapeName = shape.classList[0].split("__")[1];
      // console.log(shapeName);
      switch (shapeName) {
        case "ball":
          tl_ball_horizontal.from(shape, {
            x: 150,
            y: -60,
            opacity: 0,
            duration: 1,
          });
          break;
        case "dash-1":
          tl_ball_horizontal.from(shape, { opacity: 0 }, "-=0.83333");
          break;
        case "dash-2":
          tl_ball_horizontal.from(shape, { opacity: 0 }, "-=0.6666");
          break;
        case "dash-3":
          tl_ball_horizontal.from(shape, { opacity: 0 }, "-=0.5");
          break;
        case "dash-4":
          tl_ball_horizontal.from(shape, { opacity: 0 }, "-=0.33333");
          break;
        case "dash-5":
          tl_ball_horizontal.from(shape, { opacity: 0 }, "-=0.16666");
          break;
        case "squiggle-right":
          tl_ball_horizontal.from(
            shape,
            { opacity: 0, x: -10, y: 5, duration: 0.25 },
            "-=0.5"
          );
          break;
        case "squiggle-left":
          tl_ball_horizontal.from(
            shape,
            { opacity: 0, x: -5, y: 10, duration: 0.25 },
            "-=0.5"
          );
          break;
        default:
          break;
      }
    });
  });

  // Ball - Vertical
  const decoration_ball_vertical = document.querySelectorAll(
    ".decoration--ball-orange svg, .decoration--ball-purple svg"
  );

  decoration_ball_vertical.forEach((ball_vertical) => {
    const tl_ball_vertical = gsap.timeline({
      scrollTrigger: {
        trigger: ball_vertical,
        start: `top center`,
        end: `center center`,
      },
    });

    const shapes = Array.from(ball_vertical.children);

    tl_ball_vertical.from(shapes[0], {
      opacity: 0,
      x: -25,
      y: -100,
      duration: 1,
    });
    tl_ball_vertical.from(shapes[1], { opacity: 0 }, "-=0.666");
    tl_ball_vertical.from(shapes[2], { opacity: 0 }, "-=0.5");
    tl_ball_vertical.from(shapes[3], { opacity: 0 }, "-=0.333");
    tl_ball_vertical.from(
      shapes[4],
      { x: -10, y: 30, opacity: 0, duration: 0.25 },
      "-=0.25"
    );
    tl_ball_vertical.from(
      shapes[5],
      { x: 10, y: 30, opacity: 0, duration: 0.25 },
      "-=0.25"
    );
    tl_ball_vertical.from(shapes[6], { opacity: 0, duration: 0.25 }, "-=0.25");
    tl_ball_vertical.from(shapes[7], { opacity: 0, duration: 0.25 }, "-=0.25");
  });

  // Multi-shape
  const decoration_multi_shape = document.querySelectorAll(
    ".decoration--multi-shape svg"
  );

  decoration_multi_shape.forEach((multi_shape) => {
    gsap.from(multi_shape, {
      scrollTrigger: {
        trigger: multi_shape,
        start: `top-=100 center`,
        end: `bottom+=100 center`,
        scrub: true,
      },
      rotate: -180,
      // opacity: 0,
      // scale: 0,
      ease: "back.out(1.7)",
    });

    const tl_multi_shape = gsap.timeline({
      scrollTrigger: {
        trigger: multi_shape,
        start: `top center`,
        end: `center center`,
        scrub: true,
      },
    });

    const shapes = Array.from(multi_shape.children);

    shapes.forEach((shape) => {
      tl_multi_shape.from(shape, { opacity: 0 });
    });
  });

  // Pentagon
  const decoration_pentagon = document.querySelectorAll(
    ".decoration--pentagon svg"
  );

  decoration_pentagon.forEach((pentagon) => {
    gsap.from(pentagon, {
      scrollTrigger: {
        trigger: pentagon,
        start: `top-=100 center`,
        end: `bottom+=100 center`,
        scrub: true,
      },
      opacity: 0,
      scale: 0,
      rotate: -90,
      duration: 1,
      ease: "back.out(1.7)",
    });
  });

  // Spiral
  const decoration_spiral = document.querySelectorAll(
    ".decoration--spiral svg"
  );

  decoration_spiral.forEach((spiral) => {
    const wrapper = spiral.closest(".decoration");
    gsap.from(spiral, {
      scrollTrigger: {
        trigger: wrapper,
        start: `top-=100 center`,
        end: `bottom+=100 center`,
        scrub: true,
      },
      rotate: 360,
      scale: 0,
      opacity: 0,
      ease: "back.out(1.7)",
    });
  });

  // Squiggle
  const decoration_squiggles = document.querySelectorAll(
    ".decoration--squiggle svg"
  );

  decoration_squiggles.forEach((squiggle) => {
    const wrapper = squiggle.closest(".decoration");
    gsap.from(squiggle, {
      scrollTrigger: {
        trigger: wrapper,
        start: `top-=100 center`,
        end: `bottom+=100 center`,
        scrub: true,
      },
      opacity: 0,
      scale: 0,
      rotate: 45,
      duration: 1,
      ease: "back.out(1.7)",
    });
  });

  // Squiggle flag
  const decoration_squiggle_flag = document.querySelectorAll(
    ".decoration--squiggle-flag svg"
  );

  decoration_squiggle_flag.forEach((squiggle_flag) => {
    gsap.from(squiggle_flag, {
      scrollTrigger: {
        trigger: squiggle_flag,
        start: `top-=100 center`,
        end: `center center`,
        scrub: true,
      },
      y: 400,
      x: -200,
      opacity: 0,
    });
  });

  // Squiggle X
  const decoration_squiggle_x = document.querySelectorAll(
    ".decoration--squiggle-x svg"
  );

  decoration_squiggle_x.forEach((squiggle_x) => {
    // const section = squiggle_x.closest("section");

    const groups = squiggle_x.querySelectorAll("g");
    const overline = squiggle_x.querySelector(".overline");

    const tl_squiggle_x = gsap.timeline({
      scrollTrigger: {
        trigger: squiggle_x,
        start: `top center`,
        end: `bottom+=100 center`,
        scrub: true,
      },
    });

    tl_squiggle_x.from(overline, { strokeDashoffset: 0 });
    tl_squiggle_x.from(groups[1], { scale: 0, ease: "back.out(1.7)" });
  });
}
